export default __webpack_public_path__ + "static/media/pictogramBeaconCalendar40.44dc098b.svg";